export default __webpack_public_path__ + "static/taco@2x-215d02f950783ff91596bb5add421f1d.png";